import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
// Importee APRES App, donc apres tous les CSS de composants qu'il entraine : la
// feuille d'impression est un override par nature et doit gagner a specificite
// egale. Placee dans index.css elle serait injectee AVANT eux et perdrait.
import "./styles/print.css";
import reportWebVitals from "./reportWebVitals";
import { setupFetchInterceptor } from "./utils/fetchInterceptor";

// Configurer l'intercepteur fetch pour gérer les 401 automatiquement
setupFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
